var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Dialog',_vm._g(_vm._b({attrs:{"title":"活动规则","noOkBtn":"","noCancelBtn":"","textAlign":"left"}},'Dialog',_vm.$props,false),_vm.$listeners),[_c('div',{class:_vm.$style.rule},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }